import React from 'react'
import { Form, Formik } from 'formik'

import Input from '../../components/common/Input'
import { required } from '../../utils/validators'
import Button from '../../components/common/Button'
import Select from '../../components/common/Select'
import { useLoad } from '../../hooks/request'
import { APARTMENT_LIST, CUSTOMER_LIST } from '../../urls'

export default function ContractForm({ onCancel, onSubmit, loading, initialValues }) {
    const customer = useLoad({ url: CUSTOMER_LIST })
    const apartment = useLoad({ url: APARTMENT_LIST })
    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                customer: '',
                apartment: '',
                startDate: '',
                endDate: '',
                remainingAmount: '',
                ...initialValues,
            }}
        >
            <Form>
                <div className="columns">
                    <div className="column">

                        <Select
                            empty
                            options={customer.response?.results ?? []}
                            name="customer"
                            optionValue="id"
                            optionLabel={(e) => e?.fullName ?? ''}
                            label="Мижоз"
                            validate={required}
                            disabled={loading}
                        />
                        <Select
                            options={apartment.response?.results ?? []}
                            empty
                            name="apartment"
                            optionValue="id"
                            optionLabel={(e) => e?.apartmentNumber ?? ''}
                            label="Квартира"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="startDate"
                            type="date"
                            label="Бошлаш вақти"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="endDate"
                            type="date"
                            label="Тугатиш вақти"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="remainingAmount"
                            label="Қолган сумма"
                            validate={required}
                            disabled={loading}
                        />

                    </div>
                </div>

                <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                    <div className="button-wrapper">
                        <Button
                            onClick={onCancel}
                            icon="close-outline"
                            text="Ёпиш"
                            className="is-danger"
                        />
                    </div>
                    <div className="button-wrapper">
                        <Button
                            loading={loading}
                            text="Сақлаш"
                            icon="add-outline"
                            type="submit"
                            className="is-success"
                        />
                    </div>
                </div>
            </Form>

        </Formik>
    )
}
